import { Col, Layout, Row } from 'antd'
import { Content, Footer, Header } from 'antd/es/layout/layout'
import AnnouncementsSection from './components/AnnouncementsSection'
import ankUniLogo from './assets/ankUniLogo.png';
import Banner from './components/Banner'
export default function App() {
  return (
    <Layout>
      <Header className="ankara-header">
        <Row className="ankara-header-row" align="middle">
          <Col flex="none">
            <a href="https://www.ankara.edu.tr/">
              <img height={68} src={ankUniLogo} alt="Ankara Üniversitesi Logo" />
            </a>
          </Col>
          <Col flex="auto">
            <span className="ankara-header-title">
              ANKARA ÜNİVERSİTESİ
            </span>
          </Col>
        </Row>
      </Header>
      <Layout>
        <Content className="ankara-content">
          <Banner />
          <AnnouncementsSection />
        </Content>
      </Layout>
      {/* <Footer className="ankara-footer">Copyright © 2025 Ankara Üniversitesi</Footer> */}
    </Layout>
  )
}

